import {Component} from "@angular/core";
import {MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {DisplayCompte} from "@domain/comptabilite/compte";

/**
 * Composant d'ajout d'un compte charge
 */
@Component({
    host: {'data-test-id': 'add-compte-charge'},
    selector: 'add-compte-charge',
    templateUrl: './add-compte-charge.component.html'
})
export class AddCompteChargeComponent {
    /** Compte charge à ajouter */
    compte: DisplayCompte = new DisplayCompte();

    /**
     * Constructeur
     */
    constructor(protected matDialogRef: MatDialogRef<AddCompteChargeComponent>) {}

    /**
     * Ajout du compte charge
     */
    add(): void {
        //Mise à jour de l'affichage
        this.compte.updateDisplayName();

        //Fermeture de la boite de dialogue avec retour du nouveau compte charge
        this.matDialogRef.close(this.compte);
    }
}
